import * as React from 'react';
import PrimaryMailFolderTreeContainer from './PrimaryMailFolderTreeContainer';
import { ArchiveMailFolderTreeContainer, SharedFolderTreeParentContainer, } from 'owa-mail-folder-tree-container-view';
import { getArchiveMailboxRootFolder } from 'owa-folders';
import { observer } from 'mobx-react';
import { isControlFeatureEnabled } from 'owa-controls-feature-flags';
import { isMailFeatureEnabled } from 'owa-mail-feature-flags';
import { folderPermissionsStore, LazyFolderPermissionsDialog } from 'owa-mail-folder-permissions';
/**
 * Parent container component hosting primary, archive and shared folder tree containers
 */
function MailFolderTreesParentContainer(props) {
    var leftNavStyleWithSectionHeaders = props.leftNavStyleWithSectionHeaders, leftNavStyleWithNoSectionHeaders = props.leftNavStyleWithNoSectionHeaders, isFavoriteOrGroupListShown = props.isFavoriteOrGroupListShown;
    var shouldShowArchiveFolderTree = isControlFeatureEnabled('tri-archive-mailbox') && getArchiveMailboxRootFolder() != null;
    var shouldShowSharedFolders = isMailFeatureEnabled('tri-sharedFolders');
    // Primary root node should be shown in case of any one of the Favorites or Groups or Archive mailbox or Shared Folders is shown
    var shouldShowPrimaryRootNode = isFavoriteOrGroupListShown || shouldShowArchiveFolderTree || shouldShowSharedFolders;
    return (React.createElement(React.Fragment, null,
        React.createElement(PrimaryMailFolderTreeContainer, { showRootNode: shouldShowPrimaryRootNode, className: shouldShowPrimaryRootNode
                ? leftNavStyleWithSectionHeaders
                : leftNavStyleWithNoSectionHeaders }),
        shouldShowArchiveFolderTree && (React.createElement(ArchiveMailFolderTreeContainer, { className: leftNavStyleWithSectionHeaders })),
        shouldShowSharedFolders && (React.createElement(SharedFolderTreeParentContainer, { className: leftNavStyleWithSectionHeaders })),
        isMailFeatureEnabled('tri-folderPermissions') &&
            folderPermissionsStore.showFolderPermissionsDialog ? (React.createElement(LazyFolderPermissionsDialog, null)) : null));
}
export default observer(MailFolderTreesParentContainer);
//# sourceMappingURL=MailFolderTreesParentContainer.js.map